import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";
import type { SectionHeaderProps } from "@/components/shared/SectionHeader";
import { InventoryHeader } from "@/components/shared/Inventory";
import { MenuButton } from "@/features/navigation/MenuButton";

/** Shared row geometry is defined in page-layout.css. */
export const BAR_ROW = "page-bar";

interface TopLevelPageHeaderProps extends SectionHeaderProps {
  children?: ReactNode;
  showSafeAreaSpacer?: boolean;
  wrapperClassName?: string;
  search?: ReactNode;
  navigation?: ReactNode;
  controls?: ReactNode;
}

/**
 * Every top-level page's title bar, as natively: the menu (on root pages; pushed
 * pages render none), the title, and the page's action.
 */
export function TopLevelPageHeader({
  children,
  showSafeAreaSpacer = true,
  wrapperClassName,
  className,
  titleClassName,
  title,
  loading,
  action,
  href,
  onClick,
  search,
  navigation = <MenuButton />,
  controls,
}: TopLevelPageHeaderProps) {
  return (
    <>
      {showSafeAreaSpacer && <div className="page-safe-spacer" />}
      <div className={cn("page-heading", wrapperClassName, className)}>
        {children ? <div className="page-bar">{navigation}{children}</div> : (
          <InventoryHeader
            navigation={navigation}
            title={href ? <Link to={href} onClick={onClick}>{title}</Link> : title}
            titleClassName={cn(titleClassName, loading && "loading-dots")}
            search={search}
            action={action}
          >
            {controls}
          </InventoryHeader>
        )}
      </div>
    </>
  );
}
